
<div id="replacing-mao" class="d-md-flex justify-content-center pt-5 align-content-stretch" *ngIf="loaded">

    <div class="col-sm-12 col-md-9 col-xl-6 mb-5 d-inline-block">

        <h1>{{prefix + 'header' | translate }}</h1>

        <div class="d-md-flex justify-content-center mt-2">
            <div class="card mb-2 mx-auto w-100 card-override">
                <div class="card-body">
                    <p>{{prefix + 'detailText' | translate }}</p>
                    
                    <formly-form [form]="formGroup" [model]="model" [fields]="fields"></formly-form>
                </div>

                <div class="card-footer">
                    <button type="button" class="btn btn-secondary mr-2" (click)="close()">{{ 'ACCOUNTS_MODULE.accountSummary.close' | translate }}</button>
                    <button type="button" class="btn btn-secondary mr-2" *ngIf="release" (click)="doAction('approve')">{{ prefix + release  + '_APPLICATION' | translate }}</button>
                    <button type="button" class="btn btn-secondary mr-2" *ngIf="submission" (click)="doAction('submit')">{{ 'ACCOUNTS_MODULE.accountSummary.submitRequestTo' + userType | translate }}</button>
                    <button type="button" class="btn btn-secondary mr-2" *ngIf="editable"  (click)="doAction('approve')">{{ 'COMMON.actionsLabel.APPROVE' | translate }}</button>
                    <button type="button" class="btn btn-secondary mr-2" *ngIf="editable"  (click)="doAction('reject')">{{ 'COMMON.actionsLabel.REJECT' | translate }}</button>
                </div>

            </div>
        </div>

    </div>

</div>

